import { useTranslation } from 'react-i18next'

interface QuerySummaryProps {
  query: string
  totalResults?: number
}

export function QuerySummary({ query, totalResults }: Readonly<QuerySummaryProps>) {
  const { t } = useTranslation()

  return (
    <div className="quick-search-results-page__query-info">
      <p>
        {t('quick-search.results-for')}
        <strong>
          "
          {query}
          "
        </strong>
      </p>
      {totalResults !== undefined && (
        <p className="quick-search-results-page__results-count">
          {t('quick-search.results-count', { count: totalResults })}
        </p>
      )}
    </div>
  )
}
